import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ConfigProvider, theme } from "antd";
import "react-toastify/dist/ReactToastify.css";
import { ProtectedRoute } from "./protectedRoute";

import Login from "./scenes/login";
import { AuthProvider } from "./providers/AuthProvider";
import { Dashboard } from "./scenes/dashboard";
import { LogProvider } from "./providers/LogProvider";
import { Stats } from "./scenes/stats";
import { Alerts } from "./scenes/alerts";
import { AlertsProvider } from "./providers/AlertProvider";
import Exports from "./scenes/exports";
import Signup from "./scenes/login/Signup";
import { AccountProvider } from "./providers/AccountProvider";
import { Plans } from "./scenes/plans";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Settings } from "./scenes/settings";
import { MyApps } from "./scenes/apps";
import { Backups } from "./scenes/backups";

const stripePromise = loadStripe(
  "pk_test_51OF0xPKy7hTJ77KnWuxn9CXb6qgRqmS19ziUUTRanJbFCzpqbz57jfnrMKWKHthaN7LqDo1rmia8gh5IZ8w9BON300GaUTOWFT",
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LogProvider>
          <AlertsProvider>
            <AccountProvider>
              <Elements stripe={stripePromise}>
                <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/alerts"
                      element={
                        <ProtectedRoute>
                          <Alerts />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/usage"
                      element={
                        <ProtectedRoute>
                          <Stats />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/exports"
                      element={
                        <ProtectedRoute>
                          <Exports />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/apps"
                      element={
                        <ProtectedRoute>
                          <MyApps />
                        </ProtectedRoute>
                      }
                    />
                    {/* <Route
                      path="/account"
                      element={
                        <ProtectedRoute>
                          <Plans />
                        </ProtectedRoute>
                      }
                    /> */}
                    <Route
                      path="/settings"
                      element={
                        <ProtectedRoute>
                          <Settings />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/backups"
                      element={
                        <ProtectedRoute>
                          <Backups />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />

                    <Route
                      path="/stats"
                      element={<Navigate to="/usage" replace />}
                    />
                  </Routes>
                  <ToastContainer />
                </ConfigProvider>
              </Elements>
            </AccountProvider>
          </AlertsProvider>
        </LogProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
